import { cn, V2Badge, Icon } from '@sakhtar/design-system/react';
import { isStatutoryBook, useFinanceBook, ALL_BOOKS } from './useFinanceBook.js';

export interface BookSwitcherProps {
  /** Offer «همه دفاتر» (only meaningful for lists, not for reports). */
  readonly allowAll?: boolean;
  readonly className?: string;
}

/** The book choice shared by every finance page (see `useFinanceBook`). */
export function BookSwitcher({ allowAll = false, className = '' }: BookSwitcherProps) {
  const { books, book, isAll, select } = useFinanceBook();

  if (books.length <= 1 && !allowAll) return null;

  return (
    <div
      className={cn('sk-tabs flex items-center', className)}
      role="tablist"
      aria-label="انتخاب دفتر حسابداری"
      style={{ alignSelf: 'center' }}
    >
      <div className="flex items-center gap-1 text-[var(--sk-fg-muted)] px-2 font-medium text-xs">
        <Icon name="finance" size="sm" />
        <span>دفتر:</span>
      </div>

      {allowAll && (
        <button
          type="button"
          role="tab"
          aria-selected={isAll}
          onClick={() => select(ALL_BOOKS)}
          className={cn('sk-tab', isAll && 'is-active')}
        >
          همه دفاتر
        </button>
      )}

      {books.map((b) => {
        const isSelected = !isAll && book?.bookId === b.bookId;
        return (
          <button
            key={b.bookId}
            type="button"
            role="tab"
            aria-selected={isSelected}
            onClick={() => select(b.bookId)}
            className={cn('sk-tab inline-flex items-center gap-1.5', isSelected && 'is-active')}
          >
            <span>{b.name}</span>
            <V2Badge tone={isStatutoryBook(b) ? 'info' : 'brand'} plain={!isSelected}>
              <span className="font-mono text-[10px] dir-ltr">{b.code}</span>
            </V2Badge>
          </button>
        );
      })}
    </div>
  );
}
